import { createStyles, makeStyles, Theme } from '@material-ui/core';

/* eslint-disable max-len, @typescript-eslint/quotes */
const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({

  bottomPanel: {
    display: 'none',
    padding: 10,
    border: '1px solid #DCDEE5',
    borderTop: 'none',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  openedBottomPanel: {
    display: 'block',
  },
  saveButton: {

  },
  editor: {
    borderRadius: 4,
    border: `solid 1px ${colors.border}`,
    overflow: 'unset',
    height: 60,
    '& .codex-editor__loader': {
      display: 'none',
    },
    '& .codex-editor__loader::before': {
      top: '40px !important',
    },
    '& > .codex-editor': {
    },
    '& .codex-editor__redactor': {
      maxHeight: '25vh',
      paddingTop: 10,
      paddingBottom: '50px !important',
      margin: 'unset !important',
    },
    '& .cdx-block[contenteditable="true"]': {
      padding: '5px 20px !important',
    },
    '& .ce-block__content': {
      maxWidth: 'unset',
    },
    '& .ce-header': {
      paddingTop: '10px !important',
      paddingBottom: '15px !important',
      paddingLeft: '20px !important',
      paddingRight: '20px !important',
    },
    '& .ce-inline-tool': {
      color: '#515B6A',
    },
    '& .ce-toolbox--opened': {
      left: 34,
    },
    [`& .ce-toolbox__button[data-tool="table"], .ce-toolbox__button[data-tool="warning"],
      .ce-toolbox__button[data-tool="code"], .ce-toolbox__button[data-tool="linkTool"],
      .ce-toolbox__button[data-tool="image"], .ce-toolbox__button[data-tool="raw"],
      .ce-toolbox__button[data-tool="quote"], .ce-toolbox__button[data-tool="delimiter"]`]: {
      display: 'none',
    },
    [`& .ce-inline-tool[data-tool="link"], .ce-inline-tool[data-tool="marker"]`]: {
      display: 'none',
    },
    '& .ce-block.ce-block--focused': {
      marginRight: '0 !important',
      paddingRight: '0 !important',
    },
    '& .ce-toolbar__actions': {
      right: 0,
    },
    '& .ce-toolbar__content': {
      maxWidth: 'unset',
      position: 'unset',
    },
    '& .ce-toolbar__plus': {
      left: -5,
      display: 'none',
    },
    '& .ce-settings--opened': {
      right: 0,
    },
    '& .ce-toolbar__actions ce-toolbar__actions--opened': {
      right: 4,
    },
  },
  editorWithBottom: {
    minHeight: 140,
    height: 'auto',
    overflow: 'auto',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  scriptPreview: {
    borderRadius: 4,
    border: `solid 1px ${colors.border}`,
    overflow: 'auto',
    padding: '10px 20px',
    maxHeight: 'calc(100vh - 550px)',
    '& .ce-block__content': {
      maxWidth: 'unset',
    },
  },
}), { name: 'ArticleCommentEditor' });

export default useStyles;
